import React from "react";
import { Card } from "react-bootstrap";
import { getLogo, getSalutation, getClosing } from "./helpers";

const SeniorManagerReport: React.FC = () => (
  <Card className="padding-20px raw-email-html">
    {getLogo()}
    <hr />
    <div className="sample-email-reports-body">
      {getSalutation()}
      <p>
        Your leadership team is showing solid performance (4.0/5 across all
        metrics), though there's an emerging pattern around creative resource
        constraints affecting multiple teams. With Marcus managing an influx of
        campaign requests and Sarah's recent departure impacting David's content
        team, strategic resource planning will be crucial for maintaining Q3
        campaign momentum.
      </p>
      <hr />

      <h2>Your Direct Reports (5 Team Leaders)</h2>

      <h3>Overall Health</h3>
      <ul className="check-in-response-list">
        <li>Energy: 3.9/5 (slight dip from last week)</li>
        <li>Progress: 4.1/5 (strong execution)</li>
        <li>Readiness: 4.0/5 (well-positioned)</li>
      </ul>
      <h3>Notable Patterns</h3>
      <p>
        Rachel and David have both shown marked improvement (4.5 and 4.2
        overall), with Rachel successfully launching the partner marketing
        program and David completing the Q3 content calendar. However, creative
        bandwidth constraints are a recurring theme, with teams competing for
        limited design and video production resources.
      </p>

      <hr />

      <h2>Your Span of Control (5 Teams)</h2>

      <h3>Overall Health</h3>
      <ul className="check-in-response-list">
        <li>Energy: 3.8/5</li>
        <li>Progress: 4.0/5</li>
        <li>Readiness: 3.9/5</li>
        <li>Check-in Completion: 68% (improvement needed)</li>
      </ul>
      <h3>Key Patterns</h3>
      <p>
        Creative production bottlenecks are impacting multiple teams, with Alex
        handling overflow design requests on David's team while coordinating
        with Marcus on the product launch campaign. Meanwhile, Marcus is
        juggling competing priorities with concerns about maintaining quality
        standards across all deliverables.
      </p>
      <hr />

      <h2>Suggested Conversations This Week</h2>

      <h3>High Priority: Marcus Williams (Direct Report)</h3>
      <ul className="check-in-response-list">
        <li>Role: Creative Director, leading 6-person team</li>
        <li>
          Context: Managing 15+ active campaigns while coordinating Q3 creative
          resources
        </li>
        <li>
          Why Now: Multiple teams flagging creative capacity as risk for Q3
          launches
        </li>
        <li>
          Impact: Could delay product launch campaign and customer conference
          materials
        </li>
      </ul>

      <h3>Worth Connecting: Elena Rodriguez (Reports to Rachel Kim)</h3>
      <ul className="check-in-response-list">
        <li>Role: Digital Marketing Manager</li>
        <li>
          Context: Leading website redesign project while managing paid media
          campaigns
        </li>
        <li>
          Why Now: Energy score dropped to 3 (from 4) citing competing
          priorities
        </li>
        <li>Impact: Website launch critical for Q3 lead generation targets</li>
      </ul>

      <h3>Follow-Up: David Park (Direct Report)</h3>
      <ul className="check-in-response-list">
        <li>Role: Content Marketing Director, leading 4-person team</li>
        <li>
          Context: Delivered Q3 content calendar but facing ongoing resource
          gaps
        </li>
        <li>Why Now: Team morale concerns following Sarah's departure</li>
        <li>
          Impact: May affect thought leadership program and SEO content
          production
        </li>
      </ul>
      <hr />

      <h3>Positive Momentum</h3>
      <p>
        Rachel Kim's team has excelled in launching the partner marketing
        program ahead of schedule, generating 12 new partnership opportunities
        in just two weeks. Her overall score improved from 3.2 to 4.5,
        demonstrating the impact of clear goal-setting and successful execution.
      </p>
      <hr />
      {getClosing()}
    </div>
  </Card>
);

export default SeniorManagerReport;
